module.exports = __webpack_public_path__ + "FuturaStd-Medium.otf?95893071b7f2a535226f5e0c2c1c40c9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/FuturaStd-Medium.otf
// module id = 90
// module chunks = 0